import React  from 'react';
import './App.css';
import './Milestone.css';
import MilestoneLang from './MilestoneLang.json';

import { useNavigate } from "react-router-dom";

class MilestoneCellEdit extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			intValue: 0,
			notes: "",
			dataLoadedYN: false,
		};

		this.onKeyDown = this.onKeyDown.bind(this);
		this.serverGetMilestoneItemData = this.serverGetMilestoneItemData.bind(this);		
		this.serverUpdateMilestoneItemData = this.serverUpdateMilestoneItemData.bind(this);
		this.onValueChanged = this.onValueChanged.bind(this);
		this.onNotesChanged = this.onNotesChanged.bind(this);		
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	componentDidMount() {
		var milestoneRowID = this.props.milestoneRowID;
		var milestoneYear = this.props.milestoneYear;
		var milestoneMonth = this.props.milestoneMonth;
		var milestoneDay = 0;
		this.serverGetMilestoneItemData(milestoneRowID, milestoneYear, milestoneMonth, milestoneDay);
	}

	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	async serverGetMilestoneItemData(milestoneRowID, year, month, day) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getmilestoneitemdata?milestonerowid=" + milestoneRowID;
		url = url + "&year=" + year;
		url = url + "&month=" + month;
		url = url + "&day=" + day;
		
		try {
			const res = await fetch(url);
			const jsonObj = await res.json();

			var intValue = jsonObj.intValue;
			var notes = jsonObj.notes;
			
			this.setState({
				intValue: intValue,
				notes: notes,
				dataLoadedYN: true,
			});
		} catch {
			this.setState({
				intValue: 0,
				notes: "",
				dataLoadedYN: true,
			});
		}
	}
	
	async serverUpdateMilestoneItemData(milestoneID, milestoneRowID, year, month, day, intValue, notes, editedUserID, editedFullName) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/updatemilestoneitemdata?milestoneid=" + milestoneID;
		url = url + "&milestonerowid=" + milestoneRowID;
		url = url + "&year=" + year;
		url = url + "&month=" + month;
		url = url + "&day=" + day;
		url = url + "&intvalue=" + intValue;
		url = url + "&notes=" + encodeURIComponent(notes);
		url = url + "&editeduserid=" + editedUserID;
		url = url + "&editedfullname=" + encodeURIComponent(editedFullName);

		const res = await fetch(url);
		await res.text();
	}
		
	onValueChanged(value) {
		this.setState({intValue: value});
	}
	
	onNotesChanged(value) {
		this.setState({notes: value});
	}
	
	onClickSaveButton() {
		
		var milestoneID = this.props.milestoneID;
		var milestoneRowID = this.props.milestoneRowID;
		var milestoneRowName = this.props.milestoneRowName;
		var year = this.props.milestoneYear;
		var month = this.props.milestoneMonth;
		var day = 0;

		var intValue = this.state.intValue;
		var notes = this.state.notes;
		var editedUserID = this.props.userID;
		var editedFullName = this.props.fullName;

		this.serverUpdateMilestoneItemData(milestoneID, milestoneRowID, year, month, day, intValue, notes, editedUserID, editedFullName);
			
		this.props.showToast(this.props.getLang(MilestoneLang, "milestoneDataSaved"));
		const navigate = this.props.navigate;
  		navigate("/milestones");
	}
	
	onClickCancelButton() {
		const navigate = this.props.navigate;
  		navigate("/milestones");
	}
	
	render() {		

		if (!this.state.dataLoadedYN) {
			return null;
		}

		var milestoneID = this.props.milestoneID;
		var milestoneRowID = this.props.milestoneRowID;
		var milestoneRowName = this.props.milestoneRowName;
		var milestoneYear = this.props.milestoneYear;
		var milestoneMonth = this.props.milestoneMonth;
		
		var intValue = this.state.intValue;
		var notes = this.state.notes;
		
		var dateString = milestoneMonth + " / " + milestoneYear;

		return (
			<div className="ViewContainer1">
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">{this.props.getLang(MilestoneLang, "editMilestone")}</div>
				<div className="ViewTopText">{this.props.getLang(MilestoneLang, "editMilestoneTextInfo")}</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">{this.props.getLang(MilestoneLang, "milestoneInfo")}</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">

						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(MilestoneLang, "milestone")}</legend> 
							<input
								className="ViewItemInputDisabled" 
								type="text" 
								value={milestoneRowName}
								disabled={true}
							/>
						</fieldset>
						<div style={{height: "20px"}}></div>

						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(MilestoneLang, "month")}</legend> 
							<input
								className="ViewItemInputDisabled" 
								type="text" 
								value={dateString}
								disabled={true}
							/>
						</fieldset>
						<div style={{height: "20px"}}></div>

						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(MilestoneLang, "value")}</legend> 
							<input
								className="ViewItemInput" 
								id="partName" 
								type="number"
								defaultValue={intValue}
								autoFocus={true}
								onChange={(event) => this.onValueChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
						<div style={{height: "20px"}}></div>

						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(MilestoneLang, "notes")}</legend> 
							<textarea
								className="ViewItemInput" 
								id="notes" 
								value={notes}
								rows={10}
								onChange={(event) => this.onNotesChanged(event.target.value)}
							/>
						</fieldset>

					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>{this.props.getLang(MilestoneLang, "cancel")}</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton}>{this.props.getLang(MilestoneLang, "save")}</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function MilestoneCellEditFunction(props) {
	const navigate = useNavigate();
	return <MilestoneCellEdit {...props} navigate={navigate} />;
}

